
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiPartlycloudyPolartwilight as ObiPartlycloudyPolartwilightElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-partlycloudy-polartwilight.js';
 
 
 

 
 export const ObiPartlycloudyPolartwilight = createComponent({
   react: React,
   tagName: 'obi-partlycloudy-polartwilight',
   elementClass: ObiPartlycloudyPolartwilightElement,
   events: {
     
   }
  });
 
 